module.exports = __webpack_public_path__ + "static/media/onkar.0be365df.jpg";